import React, {useState} from 'react'
import { useNavigate } from 'react-router'
import { addIcon } from '@/assets/img/imgAssets'
import { PlusIcon, MinusIcon, TrashIcon, PencilSquareIcon } from '@heroicons/react/24/outline'
import PulseLoader from "react-spinners/PulseLoader"
import { useGetAssessmentsQuery } from './assessmentsApiSlice'

const EtAssessmentList = ({ setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }) => {
   // Created - 15 Apr 2024
  //  Author - Atul Pandey
  // Updated - 19 Aug 2025 - updated the comp with props - { setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }

  // Step 1 - set page navigation
  const navigate = useNavigate()
  
  // Step 2 - Initialize showDetails state as an object where key is the section index
    const [showDetails, setShowDetails] = useState(null)

  // Step 3 - Define the data query to get the data from the server
  const {data: assessmentsData, isLoading, isSuccess, isError, error} = useGetAssessmentsQuery()
  console.log('assessmentsData', assessmentsData)

  // Step 4 - Define Data interaction and presentation functions

    const handleToggle = (index) => {
    // Toggle the show/hide state for the specific section index
    setShowDetails(prev => prev === index ? null : index);
    }
    
    // Create an object for setting inner HTML
    const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
    }


    // Step 5 -  handle loading and error states
    if (isLoading) return <PulseLoader color={"#ea580c"} />
    if (isError) return <div>Error occurred: {error?.data?.message}</div>
  
  
    return (
        <div className='bg-gray-200 m-1 p-1 rounded'>
            {/* Header */}
            <div className='flex justify-start items-center m-1 p-1'>
    
                <div><p className='font-poppins text-2xl m-1 p-1 font-bold'>Et Assessments</p></div>
                <div>
              <img
                src={addIcon}
                alt=""
                className="h-10 w-10 cursor-pointer"
                // onClick={() => navigate("/assessments/create")}
                onClick={onAdd} // 19 Aug 2025
              />
            </div>
    
            </div>
    
            {/* Section Data */}
            <div id='assessment-data' className='bg-white rounded m-1 p-1 font-poppins'>
                {assessmentsData && assessmentsData.ids.map((id, index) => {
                    const {assessmentName, assessmentIntro, assessmentOutro, sections} = assessmentsData.entities[id]
                    return(
                    <div key={index} className=' bg-gray-200 rounded m-1 p-1'>
                        <div className='flex justify-between items-center'>
    
                            <div className='flex justify-start items-center mx-2'>
    
                              <div
                                          onClick={() => handleToggle(index)}
                                          className="mx-2 cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30  hover:bg-white"
                                      >
                                          {showDetails === index ? (
                                          <MinusIcon className="h-3 w-3 text-orange-600 " />
                                          ) : (
                                          <PlusIcon className="h-3 w-3 text-orange-600 " />
                                          )}
                                      </div> 
                            <div className='m-1 p-1' ><p className='text-sm font-bold '>{index+1} - {assessmentName}</p></div>
                            </div>
    
                            <div className='flex justify-start items-center'>
    
                                    <div 
                                    // onClick={() => navigate(`/assessments/update/${id}`)} 
                                    onClick={() => onUpdate(id)} // 19 Aug 2025 
                                    
                                    className='cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30  hover:bg-white'>
                                        <PencilSquareIcon className="h-3 w-3 text-orange-600 " />
                                    </div>
    
                                    <div 
                                    
                                    // onClick={() => navigate(`/assessments/delete/${id}`)} 
                                    
                                    onClick={() => onDelete(id)} // 19 Aug 2025
                                    
                                    className='cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30  hover:bg-white'>
                                        <TrashIcon className="h-3 w-3 text-orange-600 " />
                                    </div>
                                        
                                    
                                </div>
                          </div>
    
                          {showDetails === index && (
                            
                            <div  className=' bg-white rounded text-xs py-1'>
                                {assessmentIntro && (
                                    <div>
                                <div className='m-1 p-1'><p className='font-bold mx-2 px-2'><span className='text-black mx-1 py-1 border-b-2 border-orange-600'>Intro</span></p> </div>
                                
                                <div className='m-2 p-2 rounded border border-gray-200' > <p className='px-2 leading-4' dangerouslySetInnerHTML={createMarkup(assessmentIntro)}></p></div>
                                </div>
                                )}
                                {assessmentOutro && (
                                    <div>
                                <div className='m-1 p-1'><p className='font-bold mx-2 px-2'><span className='text-black mx-1 py-1 border-b-2 border-orange-600'>Outro</span></p> </div>
                                
                                <div className='m-2 p-2 rounded border border-gray-200' > <p className='px-2 leading-4' dangerouslySetInnerHTML={createMarkup(assessmentOutro)}></p></div>
                                </div>
                                )}
                                <div className='mx-1 px-1'><p className='font-bold p-2 rounded bg-gray-100 w-48 text-center'>Assessment Sections:</p> </div>
                                {sections && sections?.map((section, detailIndex) => (
                                <div key={detailIndex} className='flex justify-start items-center bg-gray-200 rounded mx-2 my-1 p-1'>
                                    <div className='m-1 p-1'><p className='font-bold text-gray-400'>S {detailIndex+1} :</p></div>
                                    <div className='m-1 p-1' dangerouslySetInnerHTML={createMarkup(section.sectionName)}></div>
                                </div>))}
                            </div>
                            )     
                          }
                    </div>
                )})}
    
            </div>
    
        </div>
      )
    
}

export default EtAssessmentList